import { ProgressSpinnerDesignTokens } from '@primeuix/themes/types/progressspinner';
import componentColorScheme from '../one-ds-tokens/OneDS-Component-Color-Scheme.json';
import { tFlat } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/progressspinner/index.ts
const ps = componentColorScheme.progressspinner;

export const ProgressSpinnerTelekomDT: ProgressSpinnerDesignTokens = {
  colorScheme: {
    light: {
      root: tFlat(ps),
    },
  },
};
